import { render } from "./ActivatePage.vue?vue&type=template&id=dfa6d018"
import script from "./ActivatePage.vue?vue&type=script&lang=js"
export * from "./ActivatePage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__